import * as React from "react"
import { cn } from "@/lib/utils"

export interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onCheckedChange?: (checked: boolean) => void
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, onCheckedChange, ...props }, ref) => (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        ref={ref}
        className="sr-only peer"
        onChange={(e) => onCheckedChange?.(e.target.checked)}
        {...props}
      />
      <div
        className={cn(
          "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand-300 rounded-full peer",
          "peer-checked:after:translate-x-full peer-checked:after:border-white after:content-['']",
          "after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300",
          "after:border after:rounded-full after:h-5 after:w-5 after:transition-all",
          "peer-checked:bg-brand-600",
          className
        )}
      />
    </label>
  )
)
Switch.displayName = "Switch"

export { Switch }
